import appConfig from '../appConfig';

const readNoticeIdKey = 'noticeId';

/**
 * お知らせIDを保存
 */
export function readCurrentNotice(): void {
    localStorage.setItem(readNoticeIdKey, appConfig.latestNoticeId);
}

/**
 * 最新の既読のお知らせIDを取得
 */
export function IsReadCurrentNotice(): boolean {
   return localStorage.getItem(readNoticeIdKey) === appConfig.latestNoticeId;
}